import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import { Alert, Button, Stack } from '@mui/material';

export const SectionQueryIndication = (
  latestSecQueryRaisedBy: any,
  sectionName: any,
  viewNotes: any,
  firstField: string
): React.ReactNode => {
  const handleViewSectionQueries = () => {
    viewNotes(firstField, true);
  };
  return (
    <Stack sx={{ width: '100%' }} spacing={5} className="query-alert">
      <Alert
        severity="warning"
        action={
          <Button color="inherit" size="small" onClick={handleViewSectionQueries}>
            VIEW
            <LiveHelpOutlinedIcon />
          </Button>
        }
      >
        Section query raised by {latestSecQueryRaisedBy[sectionName]}
      </Alert>
    </Stack>
  );
};
